import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
export function Header() {
  return <Box as="header" bg="#008080" h="64px" w="100%" position="fixed" top={0} left={0} zIndex={100} boxShadow="0 2px 4px rgba(0,0,0,0.2)" data-id="element-85">
      <Flex align="center" h="100%" px={4} gap={3} data-id="element-86">
        {/* Logo placeholder — oversized to hang below header */}
        <Flex align="center" justify="center" w="55px" h="55px" borderRadius="md" bg="green.700" fontSize="26px" flexShrink={0} border="2px solid rgba(255,255,255,0.3)" position="relative" top="14px" zIndex={101} boxShadow="0 2px 6px rgba(0,0,0,0.25)" data-id="element-87">
          🌿
        </Flex>
      </Flex>
    </Box>;
}